import PageNotFoundImage from '../../../assets/errorPages/pageNotFound_desktop.svg';
import PageSEO from '../PageSEO';
import ErrorPage from './ErrorPage';

const NotFoundErrorPage = () => (
	<>
		<PageSEO
			pageTitle="Page Not Found"
			description="We couldn't find the page you were looking for. It may have been moved or deleted"
		/>

		<ErrorPage
			errorMessage="We couldn't find the page you were looking for. It may have been moved or deleted."
			contactReason="you have any questions"
			svgImage={PageNotFoundImage}
			imageAltText="Page not found image"
		/>
	</>
);

export default NotFoundErrorPage;
